import { render, staticRenderFns } from "./DistributionReport.vue?vue&type=template&id=1253c7a8"
import script from "./DistributionReport.vue?vue&type=script&lang=js"
export * from "./DistributionReport.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports